// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes GW0vflYXwVmvcybNExAuJQ\\=\\= {\n\tfrom {\n\t\tscale: 0;\n\t}\n\n\tto {\n\t\tscale: 1;\n\t}\n}\n\n.JBjAKdjikJLi9HqzUkV1cg\\=\\= {\n\tanimation: GW0vflYXwVmvcybNExAuJQ\\=\\= 1s ease-in-out;\n}\n", "",{"version":3,"sources":["webpack://./src/styles.module.css"],"names":[],"mappings":"AAAA;CACC;EACC,QAAQ;CACT;;CAEA;EACC,QAAQ;CACT;AACD;;AAEA;CACC,oDAA+B;AAChC","sourcesContent":["@keyframes scale {\n\tfrom {\n\t\tscale: 0;\n\t}\n\n\tto {\n\t\tscale: 1;\n\t}\n}\n\n.box {\n\tanimation: scale 1s ease-in-out;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"box": "JBjAKdjikJLi9HqzUkV1cg==",
	"scale": "GW0vflYXwVmvcybNExAuJQ=="
};
export default ___CSS_LOADER_EXPORT___;
